// posthog config variables
export const POSTHOG_PROJECT_API_KEY = "phc_5eHqOyiCRM5hP6JVakj1RXmIRiaQkLRhWPkraJNHHiE";
export const POSTHOG_INSTANCE_ADDRESS = "https://posthog.supertokens.com";
export const buttonClickType = "button_click";
export const elementHoverType = "element_hover";
export const sectionViewType = "section_view";